import script from "./ProductsFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsFilter.vue?vue&type=script&setup=true&lang=js"

import "./ProductsFilter.vue?vue&type=style&index=0&id=69a6ea35&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69a6ea35"]])

export default __exports__